<template>
  <div>
    <OrderDetails
      :isSidebarActive="orderDetailPopupActive"
      :data="paramDetail"
      @closeSidebar="toggleDataSidebar"
    />
    <vs-card>
      <b-row>
        <b-col v-if="ROLE != 'Company'" lg="6" sm="12">
          <b-row class="mb-2">
            <b-col cols="3" align-self="center">
              <b-form-group
                :label="'* ' + $t('Customer')"
                class="vs-input--label pr-0 mr-0"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="customer"
                :options="customer_choices"
                size="small"
                label="CompanyName"
                v-on:input="
                  clearSelected();
                  getCustomerMarketplaces();
                  getCustomerActBalance();
                  getCustomerDepoList();
                "
                autocomplete
                ref="selectElement"
              >
              </v-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6" sm="12">
          <b-row class="mb-2">
            <b-col cols="3" align-self="center">
              <b-form-group
                :label="'* ' + $t('Marketplace')"
                class="vs-input--label pr-0 mr-0"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                v-model="marketplace"
                label="Name"
                :options="marketplace_choices"
                size="small"
                autocomplete
                ref="selectElement"
              >
                <template slot="option" slot-scope="option">
                  <b-row>
                    <b-col cols="2">
                      <img
                        v-if="mpControl(option.Name)"
                        :src="
                          require('../../assets/images/logo/' +
                            option.Name.trim() +
                            '.png')
                        "
                        width="30"
                        v-b-tooltip.hover.bottom="option.Name"
                        @error="errorImage"
                      />
                    </b-col>
                    <b-col>
                      {{ option.Prefix }} -
                      {{ option.Name }}
                    </b-col>
                  </b-row>
                </template>
              </v-select>
            </b-col>
          </b-row>
        </b-col>
<!--
        <b-col v-if="type != 'fullfilment'">
          <b-row align-v="center">
            <b-col cols="3" align-self="center">
              <b-form-group :label="'* ' + $t('Storehouse')" label-for="h-first-name">
              </b-form-group>
            </b-col>
            <b-col cols="7">
              <v-select
                color="danger"
                v-model="storehouse"
                :options="storehouse_choices"
                size="small"
                label="name"
                autocomplete
                ref="selectElement"
                name="storehouse"
                v-validate="'required'"
              >
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
                errors.first("storehouse")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
			-->
      </b-row>
    </vs-card>
    <vs-card>
      <b-tabs pills v-model="tabIndex" content-class="mt-3" fill>
        <vs-divider></vs-divider>

        <b-tab active>
          <template #title>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              class="vs-con-loading__container"
              id="loading-pull-order"
              v-on:click="pullOrder()"
              v-b-tooltip.hover.bottom="$t('PullOrder')"
              v-if="marketplace"
            >
              <Icon
                color="#17c3b2"
                icon="mynaui:one-circle"
                width="50"
                height="50"
                class="vs-con-loading__container"
                id="loading-pull-order"
              />
              <br />

              <h1 class="text-primary">{{ $t("PullOrder") }}</h1>
            </b-button>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              class="vs-con-loading__container"
              id="loading-pull-order"
              v-b-tooltip.hover.bottom="$t('PullOrder')"
              v-else
              disabled
            >
              <Icon
                color="#17c3b2"
                icon="mynaui:one-circle"
                width="50"
                height="50"
                class="vs-con-loading__container"
                id="loading-pull-order"
              />
              <br />

              <h1 class="text-primary">{{ $t("PullOrder") }}</h1>
            </b-button>
          </template>
        </b-tab>

        <b-tab>
          <template #title>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              v-on:click="listOrder()"
              v-b-tooltip.hover.bottom="$t('List')"
              v-if="marketplace"
            >
              <Icon color="#17c3b2" icon="ph:number-circle-two" width="50" height="50" />
              <br />

              <h1 class="text-primary">{{ $t("List") }}</h1>
            </b-button>
            <b-button
              v-else
              disabled
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              v-on:click="listOrder()"
              v-b-tooltip.hover.bottom="$t('List')"
            >
              <Icon color="#17c3b2" icon="ph:number-circle-two" width="50" height="50" />
              <br />

              <h1 class="text-primary">{{ $t("List") }}</h1>
            </b-button>
          </template>
          <ag-grid-vue
            ref="agGridTable"
            class="ag-theme-alpine w-100 my-4 ag-grid-table"
            :columnDefs="orderColumns"
            :defaultColDef="defaultColDef"
            :rowData="orderListRowData"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            @grid-ready="onGridReady"
            :suppressCopyRowsToClipboard="true"
            :suppressPaginationPanel="true"
            :localeText="localeText"
            :suppressRowClickSelection="true"
            :pinnedBottomRowData="pinnedBottomRowData"
            style="height: 500px"
            :rowClassRules="rowClassRules"
            :isRowSelectable="isRowSelectable"
          >
          </ag-grid-vue>
        </b-tab>
        <b-tab v-if="ROLE != 'Company'">
          <template #title>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              class="vs-con-loading__container"
              id="loading-pull-order"
              v-on:click="
                selectedControl();
                saveToCollect();
              "
              v-b-tooltip.hover.bottom="$t('Collect')"
              v-if="marketplace"
            >
              <Icon
                color="#17c3b2"
                icon="mynaui:three-circle"
                width="50"
                height="50"
                class="vs-con-loading__container"
                id="loading-pull-order"
              />
              <br />

              <h1 class="text-primary">{{ $t("Collect") }}</h1>
            </b-button>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              class="vs-con-loading__container"
              id="loading-pull-order"
              v-b-tooltip.hover.bottom="$t('Collect')"
              v-else
              disabled
            >
              <Icon
                color="#17c3b2"
                icon="mynaui:three-circle"
                width="50"
                height="50"
                class="vs-con-loading__container"
                id="loading-pull-order"
              />
              <br />

              <h1 class="text-primary">{{ $t("Collect") }}</h1>
            </b-button>
          </template>
        </b-tab>
        <!--
        <b-tab>
          <template #title>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              class="vs-con-loading__container"
              id="loading-pull-order"
              v-on:click="selectedControl()"
              v-b-tooltip.hover.bottom="$t('OrdersToInvoice')"
              v-if="marketplace "
            >
              <Icon
                color="#17c3b2"
                icon="mynaui:three-circle"
                width="50"
                height="50"
                class="vs-con-loading__container"
                id="loading-pull-order"
              />
              <br />

              <h1 class="text-primary">{{ $t("OrdersToInvoice") }}</h1>
            </b-button>
            <b-button
              style="
                background-color: white;
                border-color: white;
                font-size: 30px;
                box-shadow: none;
              "
              class="vs-con-loading__container"
              id="loading-pull-order"
              v-b-tooltip.hover.bottom="$t('OrdersToInvoice')"
              v-else
              disabled
            >
              <Icon
                color="#17c3b2"
                icon="mynaui:three-circle"
                width="50"
                height="50"
                class="vs-con-loading__container"
                id="loading-pull-order"
              />
              <br />

              <h1 class="text-primary">{{ $t("OrdersToInvoice") }}</h1>
            </b-button>
          </template>
          <b-row>
            <b-col cols="8">
              <vs-card>
                <b-row align-h="start">
                  <b-col cols="12" md="auto"
                    ><b-form-input
                      v-model="barcode"
                      @keyup.enter="filterOrderList()"
                      placeholder="Barkod Giriniz"
                      id="barcodeRef"
                    />
                  </b-col>
                  <b-col cols="12" md="auto">
                    <vs-button
                      @click="
                        
                        
                      "
                      type="gradient"
                      color="danger"
                      style="border-radius: 5px"
                      >{{ $t("ProductItemList") }}</vs-button
                    >
                  </b-col>
                  <b-col cols="12" md="auto">
                    <vs-button
                      @click="selectedControl()"
                      type="gradient"
                      color="primary"
                      style="border-radius: 5px"
                      >{{ $t("ClearList") }}</vs-button
                    >
                  </b-col>
                  <b-col cols="12" md="auto">
                    <vs-button
                      :disabled="completeOrderValidate"
                      @click="completeOrder()"
                      type="gradient"
                      color="success"
                      style="border-radius: 5px"
                      id="button-with-loading"
                      class="w-full vs-con-loading__container"
                      >{{ $t("CompleteOrder") }}</vs-button
                    >
                  </b-col>

                  //removed start
                  <b-col cols="12" md="auto">
                    <vs-button
                      @click="faturaCikti()"
                      type="gradient"
                      color="primary"
                      style="border-radius: 5px"
                      >Fatura Çıktısı</vs-button
                    >
                  </b-col> 
									 //removed end
                </b-row>
              </vs-card>
              <vs-card>
                <vs-table :data="findedOrderItem">
                  <template slot="thead">
                    <vs-th sort-key="OrderItemBarcode">{{
                      $t("OrderItemBarcode")
                    }}</vs-th>
                    <vs-th sort-key="OrderItemId">{{ $t("OrderItemId") }}</vs-th>
                    <vs-th sort-key="OrderItemSellerCode">{{
                      $t("OrderItemSellerCode")
                    }}</vs-th>
                    <vs-th sort-key="OrderItemMarketPlaceCode">{{
                      $t("OrderItemMarketPlaceCode")
                    }}</vs-th>
                    <vs-th sort-key="OrderItemName">{{ $t("OrderItemName") }}</vs-th>
                    <vs-th sort-key="OrderItemPrice">{{ $t("OrderItemPrice") }}</vs-th>
                    <vs-th sort-key="Appendant">{{ $t("Appendant") }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].OrderItemBarcode">
                        {{ data[indextr].OrderItemBarcode }}
                      </vs-td>
                      <vs-td :data="data[indextr].OrderItemId">
                        {{ data[indextr].OrderItemId }}
                      </vs-td>
                      <vs-td :data="data[indextr].OrderItemSellerCode">
                        {{ data[indextr].OrderItemSellerCode }}
                      </vs-td>
                      <vs-td :data="data[indextr].OrderItemMarketPlaceCode">
                        {{ data[indextr].OrderItemMarketPlaceCode }}
                      </vs-td>
                      <vs-td :data="data[indextr].OrderItemName">
                        {{ data[indextr].OrderItemName }}
                      </vs-td>
                      <vs-td :data="data[indextr].OrderItemPrice">
                        {{ data[indextr].OrderItemPrice }}
                      </vs-td>
                      <vs-td :data="data[indextr].OrderItemQuantity">
                        {{ data[indextr].OrderItemQuantity }}
                      </vs-td>
                      <vs-td :data="data[indextr].added">
                        <vs-chip
                          color="success"
                          v-if="data[indextr].added == data[indextr].OrderItemQuantity"
                        >
                          {{ data[indextr].added }}
                        </vs-chip>
                        <vs-chip color="danger" v-else-if="data[indextr].added == 0">
                          {{ data[indextr].added }}
                        </vs-chip>
                        <vs-chip color="warning" v-else>
                          {{ data[indextr].added }}
                        </vs-chip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-card>
            </b-col>
            <b-col>
              <div ref="printMeBarcode">
                <vs-card>
                  <table class="custom-table">
                    <tr v-if="invoiceNumber">
                      <th
                        class="border-item"
                        style="
                          padding: 12px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("invoiceNumber") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 12px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ invoiceNumber }}
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("OrderSource") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ OrderSource }}
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("OrderNumber") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ OrderNumber }}
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("InvoiceName") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ InvoiceName }}
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("InvoiceLastName") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ InvoiceLastName }}
                      </td>
                    </tr>

                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("InvoiceAddress") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        <h6 style="font-size: 15px">{{ InvoiceAddress }}</h6>
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("OrderCargoName") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        <h6 style="font-size: 15px">{{ OrderCargoName }}</h6>
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("OrderDate") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        <h6 style="font-size: 15px">{{ OrderDate }}</h6>
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("OrderCargoNumber") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        <h6 style="font-size: 15px">{{ OrderCargoNumber }}</h6>
                      </td>
                    </tr>
                    <tr>
                      <th
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        {{ $t("TotalPrice") }} :
                      </th>
                      <td
                        class="border-item"
                        style="
                          padding: 8px;
                          border: 1px solid black;
                          border-radius: 5px;
                          font-size: 15px;
                          font-weight: bold;
                        "
                      >
                        <h6 style="font-size: 15px">{{ TotalPrice }}</h6>
                      </td>
                    </tr>

                    <tr v-if="OrderCargoNumber" style="margin-top: 150px">
                      <td class="border-item barcode-container" colspan="2">
                        <div style="width: 100%; height: auto">
                          <barcode
                            :value="OrderCargoNumber"
                            format="CODE128"
                            tag="svg"
                            :width="5"
                            :height="150"
                            :text-options="{ fontSize: 1000 }"
                            style="width: 100%; height: auto"
                          />
                        </div>
                      </td>
                    </tr>
                  </table>
                </vs-card>
              </div>
            </b-col>
          </b-row>

          //removed   start  
					<ag-grid-vue
            ref="agGridTable"
            class="ag-theme-alpine w-100 my-4 ag-grid-table"
            :columnDefs="selectedOrderColumns"
            :defaultColDef="defaultColDef"
            :rowData="selectedOrderListRowData"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            @grid-ready="onGridReadySelected"
            :suppressCopyRowsToClipboard="true"
            :suppressPaginationPanel="true"
            :localeText="localeText"
            :suppressRowClickSelection="true"
            :pinnedBottomRowData="pinnedBottomRowDataSelectedOrders"
            style="height: 500px"
          >
          </ag-grid-vue> 
					 //removed end
        </b-tab>
			-->
      </b-tabs>
    </vs-card>
    <vs-prompt
      :title="$t('Submit')"
      :acceptText="$t('Save')"
      :cancelText="$t('Cancel')"
      @accept="ordersToInvoice"
      @cancel="toInvoiceCancel"
      @close="toInvoiceCancel"
      :active.sync="activePromptToInvoice"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span
              >{{ $t("ConfirmToInvoiceInfo") }} {{ $t("AreYSure") }}
              {{ $t("CantUndo") }}</span
            >
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="$t('Submit')"
      :acceptText="$t('applyFilter')"
      :cancelText="$t('Cancel')"
      :active.sync="activePromptToInvoiceBalanceWarning"
      color="danger"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <h5>
              <span>{{ $t("SelectedOrdersTotalPrice") }} </span>
              {{ selectedOrdersTotalPrice }}
            </h5>
            <h5>
              <span>{{ $t("CustumerBalance") }} </span>
              : {{ custumerBalance }}
            </h5>

            <h4>
              <span>{{ $t("SelectedTotalHigerThenBalance") }} </span>
              <span>{{ $t("PleaseIncreaseBalance") }} </span>
            </h4>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import OrderDetailsButton from "./CellRenderers/OrderDetailsButton.vue";
import OrderDetails from "./OrderDetails.vue";
import Barcode from "vue-barcode";
import userJson from "../../../public/user.json";
export default {
  data() {
    return {
      rowClassRules: null,
      type: userJson.type,
      orderItems: [],
      storehouse: "",
      storehouse_choices: [],
      completeOrderValidate: true,
      findedOrderItem: [],
      selectedOrdersItems: [],
      barcode: "",
      isRowSelectable: null,
      pinnedBottomRowData: null,
      pinnedBottomRowDataSelectedOrders: null,
      /////package detail
      OrderNumber: "",
      OrderCargoName: "",
      OrderCargoNumber: "",
      InvoiceName: "",
      InvoiceLastName: "",
      InvoiceAddress: "",
      InvoiceCity: "",
      InvoiceDistirct: "",
      OrderSource: "",
      OrderDate: "",
      TotalPrice: "",
      ////////////////////
      custumerBalance: 0.0,
      selectedOrdersTotalPrice: 0.0,
      ordersForInvoice: {},
      activePromptToInvoice: false,
      activePromptToInvoiceBalanceWarning: false,
      orderDetailPopupActive: false,

      paramDetail: [],
      orderColumns: [],
      selectedOrderColumns: [],
      selectedOrderListRowData: [],
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      orderList: [],
      orderListRowData: [],
      tabIndex: 0,
      colorx: "#8B0000",
      ROLE: this.$store.state.AppActiveUser.ROLE,
      customer: "",
      customer_choices: [],
      marketplace: "",
      marketplace_choices: [],
      totalOrderPrice: 0.0,
      findedOrderTotalQty: 0.0,
      findedOrderTotalAdded: 0.0,
      invoiceNumber: "",
    };
  },
  methods: {
    printBarcode() {
      const printContents = this.$refs.printMeBarcode.innerHTML;
      const originalContents = document.body.innerHTML;

      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print</title>");
      printWindow.document.write("</head><body >");
      printWindow.document.write(printContents);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
    clearSelected() {
      this.storehouse = "";
      this.marketplace = "";
    },
    getCustomerDepoList() {
      const vs = this.$vs;
      this.storehouse_choices = [];
      this.$store
        .dispatch("storehouse/listDepotAllow", this.customer.CompanyId)
        .then((response) => {
          if (response.success == true) {
            this.storehouseForCustomerList = JSON.parse(response.json);
            this.storehouseForCustomerList.forEach((val, index) => {
              this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
            });
          } else console.log(response.statusText);
        });
    },
    completeOrder() {
      var vs = this.$vs;
      vs.loading({
        container: "#button-with-loading",
        scale: 0.45,
      });
      this.activePromptToInvoice = true;
    },
    getOrderItems() {
      let selectedOrderList = [];
      this.orderItems = [];
      this.findedOrderItem = [];
      this.selectedOrderListRowData.forEach((deger, index) => {
        selectedOrderList.push({
          companyId: deger.CompanyId,
          companyInfoId: deger.CompanyInfoId,
          depotId: deger.DepotId,
          orderNumber: deger.OrderNumber,
          orderDate: deger.OrderDate,
          orderId: deger.OrderId,
          orderStatus: deger.OrderStatus,
          orderPymentType: deger.OrderPymentType == null ? "" : deger.OrderPymentType,
          orderSource: deger.OrderSource,
          orderCargoName: deger.OrderCargoName,
          orderCargoNumber: deger.OrderCargoNumber,
          orderCurrency: deger.OrderCurrency,
          orderWarehouseId: deger.OrderWarehouseId,
          shipmentName: deger.ShipmentName,
          shipmentLastName: deger.ShipmentLastName,
          shipmentAddress: deger.ShipmentAddress,
          shipmentPostalCode:
            deger.ShipmentPostalCode == null ? "" : deger.ShipmentPostalCode,
          shipmentCity: deger.ShipmentCity,
          shipmentCityCode: deger.ShipmentCityCode,
          shipmentDistirct: deger.ShipmentDistirct,
          shipmentIdentityNumber:
            deger.ShipmentIdentityNumber == null ? "" : deger.ShipmentIdentityNumber,
          shipmentPhone: deger.ShipmentPhone == null ? "" : deger.ShipmentPhone,
          shipmentMail: deger.ShipmentMail == null ? "" : deger.ShipmentMail,
          invoiceCompany: deger.InvoiceCompany,
          invoiceName: deger.InvoiceName,
          invoiceLastName: deger.InvoiceLastName,
          invoiceAddress: deger.InvoiceAddress,
          invoicePostalCode:
            deger.InvoicePostalCode == null ? "" : deger.InvoicePostalCode,
          invoiceCity: deger.InvoiceCity,
          invoiceCityCode: deger.InvoiceCityCode == null ? "" : deger.InvoiceCityCode,
          invoiceDistirct: deger.InvoiceDistirct == null ? "" : deger.InvoiceDistirct,
          invoiceIdentityNumber:
            deger.InvoiceIdentityNumber == null ? "" : deger.InvoiceIdentityNumber,
          invoicePhone: deger.InvoicePhone == null ? "" : deger.InvoicePhone,
          invoiceMail: deger.InvoiceMail == null ? "" : deger.InvoiceMail,
          invoiceTaxOffice: deger.InvoiceTaxOffice,
          invoiceTaxNumber: deger.InvoiceTaxNumber,
          customerId: deger.CustomerId,
          customer: deger.Customer,
          customerMail: deger.CustomerMail,
          customerPhone: deger.CustomerPhone == null ? "" : deger.CustomerPhone,
          totalPrice: deger.TotalPrice,
          orderNote: "",
          items: [],
        });
        deger.Items.forEach((selectedItem, selectedItemIndex) => {
          selectedOrderList[index].items.push({
            orderItemId: selectedItem.OrderItemId,
            orderItemName: selectedItem.OrderItemName,
            orderItemSellerCode: selectedItem.OrderItemSellerCode,
            orderItemMarketPlaceCode: selectedItem.OrderItemMarketPlaceCode,
            orderItemBarcode: selectedItem.OrderItemBarcode,
            orderItemVatRate: selectedItem.OrderItemVatRate,
            orderItemQuantity: selectedItem.OrderItemQuantity,
            orderItemPrice: selectedItem.OrderItemPrice,
            orderItemDiscount: selectedItem.OrderItemDiscount,
          });
        });
      });

      this.$store
        .dispatch("order/listOrderProduct", selectedOrderList)
        .then((response) => {
          if (response.success == true) {
            try {
              let orderItemsList = JSON.parse(response.json);
              orderItemsList.forEach((val, index) => {
                this.orderItems.push({
                  OrderNumber: val.OrderNumber,
                  OrderCargoName: val.OrderCargoName,
                  OrderCargoNumber: val.OrderCargoNumber,
                  InvoiceName: val.InvoiceName,
                  InvoiceLastName: val.InvoiceLastName,
                  InvoiceAddress: val.InvoiceAddress,
                  InvoiceCity: val.InvoiceCity,
                  InvoiceDistirct: val.InvoiceDistirct,
                  OrderSource: val.OrderSource,
                  OrderDate: val.OrderDate,
                  TotalPrice: val.TotalPrice,
                  OrderItemId: val.OrderItemId,
                  OrderItemName: val.OrderItemName,
                  OrderItemSellerCode: val.OrderItemSellerCode,
                  OrderItemMarketPlaceCode: val.OrderItemMarketPlaceCode,
                  OrderItemBarcode: val.OrderItemBarcode,
                  OrderItemVatRate: val.OrderItemVatRate,
                  OrderItemQuantity: val.OrderItemQuantity,
                  OrderItemPrice: val.OrderItemPrice,
                  OrderItemDiscount: val.OrderItemDiscount,
                  added: 0,
                });
              });
              if (this.barcode != "") {
                let deger = this.orderItems.find(
                  (item) => item.OrderItemBarcode === this.barcode
                );
                this.OrderNumber = deger.OrderNumber;
                this.OrderCargoName = deger.OrderCargoName;
                this.OrderCargoNumber = deger.OrderCargoNumber;
                this.InvoiceName = deger.InvoiceName;
                this.InvoiceLastName = deger.InvoiceLastName;
                this.InvoiceAddress = deger.InvoiceAddress;
                this.InvoiceCity = deger.InvoiceCity;
                this.InvoiceDistirct = deger.InvoiceDistirct;
                this.OrderSource = deger.OrderSource;
                this.OrderDate = deger.OrderDate;
                this.TotalPrice = deger.TotalPrice;
                this.findedOrderItem = this.orderItems.filter(
                  (item) => item.OrderNumber === this.OrderNumber
                );
                if (deger) {
                  let index = this.findedOrderItem.indexOf(deger);
                  this.findedOrderItem[index].added = 1;
                  this.barcode = "";
                } else {
                  vs.notify({
                    text: this.$t("NotInList"),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    position: "top-center",
                  });
                }
                this.findedOrderItem.forEach((val, index) => {
                  this.findedOrderTotalQty += val.OrderItemQuantity;
                  this.findedOrderTotalAdded += val.added;
                });
                if (this.findedOrderTotalQty == this.findedOrderTotalAdded)
                  this.completeOrderValidate = false;
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            vs.notify({
              text: response.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },

    filterOrderList() {
      try {
        var vs = this.$vs;
        this.findedOrderTotalQty = 0.0;
        this.findedOrderTotalAdded = 0.0;
        if (this.OrderNumber == "") {
          this.getOrderItems();
        } else {
          let deger = this.findedOrderItem.find(
            (item) => item.OrderItemBarcode === this.barcode
          );
          let index = this.findedOrderItem.indexOf(deger);

          if (
            this.findedOrderItem[index].OrderItemQuantity <=
            this.findedOrderItem[index].added
          ) {
            vs.notify({
              text: this.$t("GreaterThanQuantity"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          } else {
            this.findedOrderItem[index].added = this.findedOrderItem[index].added + 1;
            this.barcode = "";
          }

          this.findedOrderItem.forEach((val, index) => {
            this.findedOrderTotalQty += val.OrderItemQuantity;
            this.findedOrderTotalAdded += val.added;
          });
          if (this.findedOrderTotalQty == this.findedOrderTotalAdded)
            this.completeOrderValidate = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    createData(count, prefix) {
      var result = [];
      let newObj = {};
      newObj["TotalPrice"] = this.totalOrderPrice;
      newObj["OrderNumber"] = this.orderList.Orders.length;

      result.push(newObj);
      return result;
    },
    createDataSelectedOrders(count, prefix) {
      var result = [];
      let newObj = {};
      newObj["TotalPrice"] = this.selectedOrdersTotalPrice;

      result.push(newObj);
      return result;
    },
    toInvoiceCancel() {
      var vs = this.$vs;
      setTimeout(() => {
        vs.loading.close("#button-with-loading > .con-vs-loading");
      }, 1000);
    },
    clearSelectedOrder() {
      this.barcode = "";
      this.OrderNumber = "";
      this.OrderCargoName = "";
      this.OrderCargoNumber = "";
      this.InvoiceName = "";
      this.InvoiceLastName = "";
      this.InvoiceAddress = "";
      this.InvoiceCity = "";
      this.InvoiceDistirct = "";
      this.OrderSource = "";
      this.OrderDate = "";
      this.TotalPrice = "";
      //    this.selectedOrdersItems = [];
      this.findedOrderItem = [];
      this.completeOrderValidate = true;
      this.findedOrderTotalQty = 0.0;
      this.findedOrderTotalAdded = 0.0;
      var vs = this.$vs;
      setTimeout(() => {
        vs.loading.close("#button-with-loading > .con-vs-loading");
      }, 1000);
    },
    saveToCollect() {
      var vs = this.$vs;
      let selectedOrderList = [];
      this.orderItems = [];
      this.findedOrderItem = [];
      this.selectedOrderListRowData.forEach((deger, index) => {
        selectedOrderList.push({
          companyId: deger.CompanyId,
          companyInfoId: deger.CompanyInfoId,
          depotId: deger.DepotId,
          orderNumber: deger.OrderNumber,
          orderDate: deger.OrderDate,
          orderId: deger.OrderId,
          orderStatus: deger.OrderStatus,
          orderPymentType: deger.OrderPymentType == null ? "" : deger.OrderPymentType,
          orderSource: deger.OrderSource,
          orderCargoName: deger.OrderCargoName,
          orderCargoNumber: deger.OrderCargoNumber,
          orderCurrency: deger.OrderCurrency,
          orderWarehouseId: deger.OrderWarehouseId,
          shipmentName: deger.ShipmentName,
          shipmentLastName: deger.ShipmentLastName,
          shipmentAddress: deger.ShipmentAddress,
          shipmentPostalCode:
            deger.ShipmentPostalCode == null ? "" : deger.ShipmentPostalCode,
          shipmentCity: deger.ShipmentCity,
          shipmentCityCode: deger.ShipmentCityCode,
          shipmentDistirct: deger.ShipmentDistirct,
          shipmentIdentityNumber:
            deger.ShipmentIdentityNumber == null ? "" : deger.ShipmentIdentityNumber,
          shipmentPhone: deger.ShipmentPhone == null ? "" : deger.ShipmentPhone,
          shipmentMail: deger.ShipmentMail == null ? "" : deger.ShipmentMail,
          invoiceCompany: deger.InvoiceCompany,
          invoiceName: deger.InvoiceName,
          invoiceLastName: deger.InvoiceLastName,
          invoiceAddress: deger.InvoiceAddress,
          invoicePostalCode:
            deger.InvoicePostalCode == null ? "" : deger.InvoicePostalCode,
          invoiceCity: deger.InvoiceCity,
          invoiceCityCode: deger.InvoiceCityCode == null ? "" : deger.InvoiceCityCode,
          invoiceDistirct: deger.InvoiceDistirct == null ? "" : deger.InvoiceDistirct,
          invoiceIdentityNumber:
            deger.InvoiceIdentityNumber == null ? "" : deger.InvoiceIdentityNumber,
          invoicePhone: deger.InvoicePhone == null ? "" : deger.InvoicePhone,
          invoiceMail: deger.InvoiceMail == null ? "" : deger.InvoiceMail,
          invoiceTaxOffice: deger.InvoiceTaxOffice,
          invoiceTaxNumber: deger.InvoiceTaxNumber,
          customerId: deger.CustomerId,
          customer: deger.Customer,
          customerMail: deger.CustomerMail,
          customerPhone: deger.CustomerPhone == null ? "" : deger.CustomerPhone,
          totalPrice: deger.TotalPrice,
          orderNote: "",
          items: [],
        });
        deger.Items.forEach((selectedItem, selectedItemIndex) => {
          selectedOrderList[index].items.push({
            orderItemId: selectedItem.OrderItemId,
            orderItemName: selectedItem.OrderItemName,
            orderItemSellerCode: selectedItem.OrderItemMarketPlaceCode,
            orderItemMarketPlaceCode: selectedItem.OrderItemMarketPlaceCode,
            orderItemBarcode: selectedItem.OrderItemBarcode,
            orderItemVatRate: selectedItem.OrderItemVatRate,
            orderItemQuantity: selectedItem.OrderItemQuantity,
            orderItemPrice: selectedItem.OrderItemPrice,
            orderItemDiscount: selectedItem.OrderItemDiscount,
          });
        });
      });
      let selectedAllOrdersList = {
        companyInfoId: this.marketplace.CompanyInfoId,
        depotId: null,
        totalItem: 0,
        totalPage: 0,
        page: 0,
        orders: selectedOrderList,
      };
			console.log(JSON.stringify(selectedAllOrdersList))
      if (this.ROLE == "Company") {
        vs.notify({
          text: this.$t("NotAuthority"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else
        this.$store
          .dispatch("order/addOrderToColect", selectedAllOrdersList)
          .then((response) => {
            if (response.status == 200) {
              try {
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.clearSelectedOrder();
              } catch (error) {
                console.log(error);
                vs.notify({
                  text: error,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              }

              setTimeout(() => {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              }, 1000);
            } else {
              console.log(response.data);
              setTimeout(() => {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              }, 1000);
              if (
                response.data.message.toString().includes("Orders item not stock list.")
              ) {
                let errorMessage = response.data.message.toString().split(".");
                vs.notify({
                  text: this.$t("OrderItemNotInShelf") + ":" + errorMessage[1],
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
              } else
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
            }
          })
          .catch((error) => {
            vs.notify({
              text: error.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          });
    },
    selectedControl() {
      this.selectedOrderListRowData = this.gridApi.getSelectedRows();
      this.clearSelectedOrder();
      this.selectedOrdersItems = [];
      if (this.selectedOrderListRowData.length > 0) {
        this.selectedOrdersTotalPrice = 0.0;
        this.selectedOrderListRowData.forEach((val, index) => {
          this.selectedOrdersTotalPrice += val.TotalPrice;
        });
        if (this.selectedOrdersTotalPrice > this.custumerBalance) {
          //    this.activePromptToInvoiceBalanceWarning = true;
          setTimeout(() => {
            this.tabIndex = 1;
          }, 1000);
        } else {
          this.selectedOrderColumns = this.orderColumns;
          this.pinnedBottomRowDataSelectedOrders = this.createDataSelectedOrders(
            1,
            "Bottom"
          );
          /* setTimeout(() => {
            document.getElementById("barcodeRef").focus();
          }, 1000);*/
        }
      } else {
        setTimeout(() => {
          this.tabIndex = 1;
        }, 1000);

        var vs = this.$vs;
        vs.notify({
          text: this.$t("ConfirmToSelected"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    toggleDataSidebar(val = false) {
      this.orderDetailPopupActive = val;
    },
    orderDetail() {
      this.orderDetailPopupActive = true;
    },
    currencyFormatter(params) {
      let currency = params.data.currencyCode;
      let price = params.value;
      if (currency == "TL" || currency == "TRY")
        return new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
        }).format(parseFloat(price));
      else if (currency == "USD")
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(parseFloat(price));
      else if (currency == "EUR") {
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
        }).format(parseFloat(price));
      }
    },
    onGridReadySelected(params) {
      this.gridApiSelected = params.api;
      this.gridColumnApiSelected = params.columnApi;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    listOrder() {
      try {
        this.orderColumns = [];
        let columnList = Object.keys(this.orderList.Orders[0]);
        this.totalOrderPrice = 0.0;
        this.ItemCount = 0.0;
        this.orderList.Orders.forEach((val, index) => {
          this.totalOrderPrice += val.TotalPrice;
        });
        this.orderColumns.push({
          width: 100,
          pinned: "left",
          headerCheckboxSelection: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          cellRendererFramework: "OrderDetailsButton",
          filter: "agSetColumnFilter",
          //params for info button
          cellRendererParams: {
            addMethods: "orderDetail", // methods for info button
            addIcon: "icon-park-outline:doc-detail", // icon for info button
            iconColor: "#17c3b2",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "OrderNumber" || val == "InvoiceName" || val == "InvoiceLastName") {
            this.orderColumns.push({
              width: 100,
              headerName: this.$t(val),
              field: val,
              pinned: "left",
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          } else if (val.includes("Amount") == true || val.includes("Price") == true) {
            this.orderColumns.push({
              width: 100,
              headerName: this.$t(val),
              pinned: "left",
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: this.currencyFormatter,
            });
          } else if (
            val != "Items" &&
            val != "id" &&
            val != "packageHistories" &&
            val != "timeSlotId" &&
            val != "scheduledDeliveryStoreId" &&
            val != "originShipmentDate" &&
            val != "lastModifiedDate" &&
            val != "commercial" &&
            val != "shipmentAddress" &&
            val != "invoiceAddress" &&
            val.includes("Id") == false
          )
            this.orderColumns.push({
              width: 100,
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
        });
        this.pinnedBottomRowData = this.createData(1, "Bottom");
        console.log(this.pinnedBottomRowData);
      } catch (error) {
        console.log(error);
      }
    },
    ordersToInvoice() {
      var vs = this.$vs;
      let selectedOrderList = [];

      let deger = this.selectedOrderListRowData.find(
        (item) => item.OrderNumber === this.OrderNumber
      );
      selectedOrderList.push({
        companyId: deger.CompanyId,
        companyInfoId: deger.CompanyInfoId,
        depotId: deger.DepotId == null ? this.storehouse.value : deger.DepotId,
        orderNumber: deger.OrderNumber,
        orderDate: deger.OrderDate,
        orderId: deger.OrderId,
        orderStatus: deger.OrderStatus,
        orderPymentType: deger.OrderPymentType == null ? "" : deger.OrderPymentType,
        orderSource: deger.OrderSource,
        orderCargoName: deger.OrderCargoName,
        orderCargoNumber: deger.OrderCargoNumber,
        orderCurrency: deger.OrderCurrency,
        orderWarehouseId: deger.OrderWarehouseId,
        shipmentName: deger.ShipmentName,
        shipmentLastName: deger.ShipmentLastName,
        shipmentAddress: deger.ShipmentAddress,
        shipmentPostalCode:
          deger.ShipmentPostalCode == null ? "" : deger.ShipmentPostalCode,
        shipmentCity: deger.ShipmentCity,
        shipmentCityCode: deger.ShipmentCityCode,
        shipmentDistirct: deger.ShipmentDistirct,
        shipmentIdentityNumber:
          deger.ShipmentIdentityNumber == null ? "" : deger.ShipmentIdentityNumber,
        shipmentPhone: deger.ShipmentPhone == null ? "" : deger.ShipmentPhone,
        shipmentMail: deger.ShipmentMail == null ? "" : deger.ShipmentMail,
        invoiceCompany: deger.InvoiceCompany,
        invoiceName: deger.InvoiceName,
        invoiceLastName: deger.InvoiceLastName,
        invoiceAddress: deger.InvoiceAddress,
        invoicePostalCode: deger.InvoicePostalCode == null ? "" : deger.InvoicePostalCode,
        invoiceCity: deger.InvoiceCity,
        invoiceCityCode: deger.InvoiceCityCode == null ? "" : deger.InvoiceCityCode,
        invoiceDistirct: deger.InvoiceDistirct == null ? "" : deger.InvoiceDistirct,
        invoiceIdentityNumber:
          deger.InvoiceIdentityNumber == null ? "" : deger.InvoiceIdentityNumber,
        invoicePhone: deger.InvoicePhone == null ? "" : deger.InvoicePhone,
        invoiceMail: deger.InvoiceMail == null ? "" : deger.InvoiceMail,
        invoiceTaxOffice: deger.InvoiceTaxOffice,
        invoiceTaxNumber: deger.InvoiceTaxNumber,
        customerId: deger.CustomerId,
        customer: deger.Customer,
        customerMail: deger.CustomerMail,
        customerPhone: deger.CustomerPhone == null ? "" : deger.CustomerPhone,
        totalPrice: deger.TotalPrice,
        orderNote: "",
        items: [],
      });
      deger.Items.forEach((selectedItem, selectedItemIndex) => {
        selectedOrderList[0].items.push({
          orderItemId: selectedItem.OrderItemId,
          orderItemName: selectedItem.OrderItemName,
          orderItemSellerCode: selectedItem.OrderItemMarketPlaceCode,
          orderItemMarketPlaceCode: selectedItem.OrderItemMarketPlaceCode,
          orderItemBarcode: selectedItem.OrderItemBarcode,
          orderItemVatRate: selectedItem.OrderItemVatRate,
          orderItemQuantity: selectedItem.OrderItemQuantity,
          orderItemPrice: selectedItem.OrderItemPrice,
          orderItemDiscount: selectedItem.OrderItemDiscount,
        });
      });
      this.ordersForInvoice = {
        totalItem: 0,
        totalPage: 0,
        page: 0,
        orders: selectedOrderList,
      };

      this.$store
        .dispatch("order/sendOrderToArchive", this.ordersForInvoice)
        .then((response) => {
          if (response.success == true) {
            vs.notify({
              text: response.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            try {
              let invoiceJson = JSON.parse(response.json);
              this.invoiceNumber = invoiceJson.invoice_id;
              this.printBarcode();

              this.clearSelectedOrder();
            } catch (error) {
              console.log(error);
            }

            setTimeout(() => {
              vs.loading.close("#button-with-loading > .con-vs-loading");
            }, 1000);
          } else {
            setTimeout(() => {
              vs.loading.close("#button-with-loading > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    pullOrder() {
      let type = "material";
      var vs = this.$vs;
      if (this.marketplace == "") {
        vs.notify({
          text: this.$t("Validate"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        vs.loading({
          container: `#loading-pull-order`,
          type,
          scale: 0.75,
        });
        let obj = { companyInfoId: this.marketplace.CompanyInfoId };
        this.$store
          .dispatch("order/pullOrder", obj)
          .then((response) => {
            if (response.success == true) {
              this.tabIndex = 1;
              this.orderList = JSON.parse(response.json);
              this.orderListRowData = this.orderList.Orders;
              this.listOrder();
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              setTimeout(() => {
                vs.loading.close("#loading-pull-order > .con-vs-loading");
              }, 1000);
            } else {
              if (typeof response.message == "undefined")
                vs.notify({
                  text: response.status + ":" + this.$t("OrderCantFindErrorMessage"),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              else {
                vs.notify({
                  text: response.status + ":" + response.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
              setTimeout(() => {
                vs.loading.close("#loading-pull-order > .con-vs-loading");
              }, 1000);
            }
          })
          .catch((error) => {
            setTimeout(() => {
              vs.loading.close("#loading-pull-order > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: error.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      }
    },
    formSubmitted() {
      alert("Form submitted!");
    },
    errorImage(e) {
      if (e.type == "error")
        e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
    },
    mpControl(e) {
      if (
        !e.includes("Toplu") &&
        !e.includes("Flip") &&
        !e.includes("Php") &&
        !e.includes("Tümü")
      )
        return true;
      else return false;
    },
    getCustomerActBalance() {
      const vs = this.$vs;
      this.$store
        .dispatch("customer/listCustomerActBalance", this.customer.CompanyId)
        .then((response) => {
          // let costumerList = JSON.parse(response.json);
          if (response.success == true) {
            this.custumerBalance = JSON.parse(response.json).companyBalance;
          } else console.log(response.statusText);
        });
    },
    getCustomerMarketplaces() {
      const vs = this.$vs;
      this.timelineData = [];
      let compId = this.customer.CompanyId;
      if (this.ROLE == "Company") compId = this.activeUserInfo.companyid;
      this.$store
        .dispatch("customer/listCustomerinfoForRole", compId)
        .then((response) => {
          // let costumerList = JSON.parse(response.json);
          if (response.success == true) {
            this.marketplace_choices = this.$store.state.customer.CustomerInfoListForCustomer;
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    company: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  watch: {
    company(val) {
      this.customer_choices = val;
      return val;
    },
  },
  components: {
    Barcode,

    OrderDetails,
    OrderDetailsButton,
    TextViewCellRenderer,
    AgGridVue,
    FormWizard,
    TabContent,
    vSelect,
    Icon,
  },
  created() {
    this.customer_choices = this.company;
    if (this.ROLE == "Company") {
      this.getCustomerMarketplaces();
      this.getCustomerDepoList();
    }
    this.rowClassRules = {
      "bg-danger-list-ag": (params) => {
        return !params.data.IsQuantityExsist;
      },
      "bg-success": (params) => {
        var difference = params.data.isCreate;
        return difference == "success";
      },
    };
    this.isRowSelectable = (node) => {
      return node.data ? node.data.IsQuantityExsist === true : false;
    };
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("orderDetail", (paramDetail) => {
      this.paramDetail = paramDetail;
      this.orderDetail();
    });
  },
  beforeDestroy() {
    this.$root.$off("orderDetail");
  },
};
</script>
<style lang="scss">
[dir] .nav-pills .nav-link.active,
[dir] .nav-pills .show > .nav-link {
  background-color: white;
}
[dir] .nav-pills .nav-link.active,
[dir] .nav-pills .show > .nav-link {
  border-bottom: 3px solid rgb(23, 195, 178);
}
.bg-danger-list-ag {
  background-color: #f8cbcc !important;
}
</style>
